import React, {
    useEffect,
    useState
} from "react";

import {
    useNavigate
} from "react-router-dom";

import Cookies from "js-cookie";

import UserSidebar from "../components/user/UserSidebar";
import UserHeader from "../components/user/UserHeader";

import {
    userMe,
    getPremiumSubjects
} from "../config/userApi";

import "./PremiumMCQ.css";


function PremiumMCQ() {

    const navigate = useNavigate();


    /*
    |--------------------------------------------------------------------------
    | State
    |--------------------------------------------------------------------------
    */

    const [
        sidebarOpen,
        setSidebarOpen
    ] = useState(false);


    const [
        name,
        setName
    ] = useState("Student");


    const [
        subjects,
        setSubjects
    ] = useState([]);


    const [
        purchased,
        setPurchased
    ] = useState(false);


    const [
        loading,
        setLoading
    ] = useState(true);


    const [
        error,
        setError
    ] = useState("");


    /*
    |--------------------------------------------------------------------------
    | Load Premium Subjects
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        const loadPremiumSubjects = async () => {

            try {

                setLoading(true);

                setError("");


                /*
                |--------------------------------------------------------------------------
                | Check Logged In User
                |--------------------------------------------------------------------------
                */

                const meResponse =
                    await userMe();


                console.log(
                    "USER ME STATUS:",
                    meResponse.status
                );


                /*
                |--------------------------------------------------------------------------
                | User Not Logged In
                |--------------------------------------------------------------------------
                */

                if (
                    meResponse.status === 401
                ) {

                    Cookies.remove(
                        "username"
                    );


                    navigate(
                        "/login",
                        {
                            replace: true
                        }
                    );


                    return;
                }


                /*
                |--------------------------------------------------------------------------
                | User Response
                |--------------------------------------------------------------------------
                */

                const meResult =
                    await meResponse.json();


                console.log(
                    "USER ME RESPONSE:",
                    meResult
                );


                if (!meResponse.ok) {

                    throw new Error(
                        meResult.message ||
                        "Unable to verify user."
                    );

                }


                /*
                |--------------------------------------------------------------------------
                | Set User Name
                |--------------------------------------------------------------------------
                */

                if (
                    meResult.user
                ) {

                    const username =
                        meResult.user.fullname ||
                        meResult.user.name ||
                        meResult.user.username ||
                        "Student";


                    setName(
                        username
                    );
                }


                /*
                |--------------------------------------------------------------------------
                | Get Premium Subjects
                |--------------------------------------------------------------------------
                */

                const response =
                    await getPremiumSubjects();


                console.log(
                    "PREMIUM SUBJECTS STATUS:",
                    response.status
                );


                /*
                |--------------------------------------------------------------------------
                | Unauthorized
                |--------------------------------------------------------------------------
                */

                if (
                    response.status === 401
                ) {

                    Cookies.remove(
                        "username"
                    );


                    navigate(
                        "/login",
                        {
                            replace: true
                        }
                    );


                    return;
                }


                /*
                |--------------------------------------------------------------------------
                | Read API Response
                |--------------------------------------------------------------------------
                */

                const result =
                    await response.json();


                console.log(
                    "PREMIUM SUBJECTS RESPONSE:",
                    result
                );


                if (!response.ok) {

                    throw new Error(
                        result.message ||
                        "Unable to fetch premium subjects."
                    );

                }


                /*
                |--------------------------------------------------------------------------
                | Purchase Status
                |--------------------------------------------------------------------------
                */

                setPurchased(
                    result.purchased === true
                );


                /*
                |--------------------------------------------------------------------------
                | Subjects
                |--------------------------------------------------------------------------
                */

                setSubjects(
                    Array.isArray(
                        result.data
                    )
                        ? result.data
                        : []
                );


            } catch (err) {

                console.error(
                    "PREMIUM SUBJECTS ERROR:",
                    err
                );


                setError(
                    err.message ||
                    "Unable to connect with server."
                );


            } finally {

                setLoading(false);

            }

        };


        loadPremiumSubjects();

    }, [navigate]);


    /*
    |--------------------------------------------------------------------------
    | Open Subject
    |--------------------------------------------------------------------------
    */

    const openSubject = (
        subject
    ) => {

        navigate(
            `/premium-mcq/subject/${encodeURIComponent(
                subject
            )}`
        );
    };


    /*
    |--------------------------------------------------------------------------
    | Loading
    |--------------------------------------------------------------------------
    */

    if (loading) {

        return (

            <div className="user-dashboard">


                {/* SIDEBAR */}

                <UserSidebar
                    sidebarOpen={
                        sidebarOpen
                    }
                    setSidebarOpen={
                        setSidebarOpen
                    }
                />


                {/* MAIN */}

                <main className="dashboard-main">


                    {/* HEADER */}

                    <UserHeader
                        name={name}
                        setSidebarOpen={
                            setSidebarOpen
                        }
                    />


                    {/* LOADING */}

                    <div className="premium-mcq-loading">

                        <div
                            className="spinner-border text-primary"
                            role="status"
                        >

                            <span className="visually-hidden">
                                Loading...
                            </span>

                        </div>


                        <p className="mt-3">
                            Loading Premium Subjects...
                        </p>

                    </div>

                </main>

            </div>

        );
    }


    /*
    |--------------------------------------------------------------------------
    | Main UI
    |--------------------------------------------------------------------------
    */

    return (

        <div className="user-dashboard premium-mcq-page">


            {/* =========================================================
                SIDEBAR
            ========================================================= */}

            <UserSidebar
                sidebarOpen={
                    sidebarOpen
                }
                setSidebarOpen={
                    setSidebarOpen
                }
            />


            {/* =========================================================
                MAIN
            ========================================================= */}

            <main className="dashboard-main">


                {/* =========================================================
                    HEADER
                ========================================================= */}

                <UserHeader
                    name={name}
                    setSidebarOpen={
                        setSidebarOpen
                    }
                />


                {/* =========================================================
                    CONTENT
                ========================================================= */}

                <div className="dashboard-content">


                    {/* =====================================================
                        PREMIUM HEADER
                    ===================================================== */}

                    <section className="premium-mcq-header">


                        <div className="premium-header-content">


                            <span className="premium-mcq-badge">

                                <i className="bi bi-gem"></i>

                                PREMIUM MCQs

                            </span>


                            <h1>
                                Premium MCQ Practice
                            </h1>


                            <p>
                                Select a subject to continue
                                your premium MCQ practice.
                            </p>

                        </div>


                        <div className="premium-header-icon">

                            <i className="bi bi-gem"></i>

                        </div>

                    </section>


                    {/* =====================================================
                        ERROR
                    ===================================================== */}

                    {error && (

                        <div className="alert alert-danger mt-4">

                            <i className="bi bi-exclamation-triangle-fill me-2"></i>

                            {error}

                        </div>

                    )}


                    {/* =====================================================
                        NOT PURCHASED
                    ===================================================== */}

                    {!error &&
                        !purchased && (

                            <div className="premium-lock-card">


                                <div className="premium-lock-icon">

                                    <i className="bi bi-lock-fill"></i>

                                </div>


                                <span className="locked-label">

                                    PREMIUM ACCESS

                                </span>


                                <h2>
                                    Premium MCQs Locked
                                </h2>


                                <p>
                                    You have not purchased the
                                    Premium MCQ package yet.
                                </p>


                                <p className="text-muted">

                                    Purchase MCQ to unlock all
                                    premium subjects and papers.

                                </p>


                                <a
                                    href="https://imjo.in/58z6sD"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="premium-purchase-btn"
                                >

                                    <i className="bi bi-gem"></i>

                                    Purchase MCQ Now

                                    <i className="bi bi-arrow-right"></i>

                                </a>

                            </div>

                        )
                    }


                    {/* =====================================================
                        PURCHASED BUT NO SUBJECTS
                    ===================================================== */}

                    {!error &&
                        purchased &&
                        subjects.length === 0 && (

                            <div className="premium-lock-card">


                                <div className="premium-lock-icon">

                                    <i className="bi bi-journal-x"></i>

                                </div>


                                <h3>
                                    No Premium Subjects Available
                                </h3>


                                <p>

                                    Premium MCQ subjects are
                                    currently not available.

                                </p>

                            </div>

                        )
                    }


                    {/* =====================================================
                        SUBJECTS
                    ===================================================== */}

                    {!error &&
                        purchased &&
                        subjects.length > 0 && (

                            <section className="premium-subjects-wrapper">


                                {/* =================================================
                                    SECTION HEADER
                                ================================================= */}

                                <div className="premium-section-header mb-4">


                                    <div className="subject-title-wrapper">


                                        <div className="subject-icon">

                                            <i className="bi bi-book"></i>

                                        </div>


                                        <div>

                                            <h2>
                                                Select Subject
                                            </h2>


                                            <p>
                                                Choose a subject
                                                to view available
                                                papers.
                                            </p>

                                        </div>

                                    </div>


                                    <span className="premium-pro-badge">

                                        <i className="bi bi-gem"></i>

                                        PRO

                                    </span>

                                </div>


                                {/* =================================================
                                    SUBJECT CARDS
                                ================================================= */}

                                <div className="row g-4">


                                    {subjects.map(
                                        (
                                            subject,
                                            index
                                        ) => (

                                            <div
                                                className="col-xl-4 col-lg-6 col-md-6"
                                                key={
                                                    subject.subject ||
                                                    index
                                                }
                                            >


                                                <div
                                                    className="premium-paper-card premium-subject-card"
                                                    onClick={() =>
                                                        openSubject(
                                                            subject.subject
                                                        )
                                                    }
                                                >


                                                    {/* CARD TOP */}

                                                    <div className="paper-card-top">


                                                        <div className="premium-paper-number">

                                                            {String(
                                                                index + 1
                                                            ).padStart(
                                                                2,
                                                                "0"
                                                            )}

                                                        </div>


                                                        <span className="premium-card-badge">

                                                            <i className="bi bi-gem"></i>

                                                            PRO

                                                        </span>

                                                    </div>


                                                    {/* SUBJECT ICON */}

                                                    <div className="premium-paper-icon">

                                                        <i className="bi bi-book-half"></i>

                                                    </div>


                                                    {/* SUBJECT NAME */}

                                                    <h3>
                                                        {subject.subject}
                                                    </h3>


                                                    {/* PAPER COUNT */}

                                                    <div className="premium-question-info">


                                                        <div className="question-icon">

                                                            <i className="bi bi-journal-text"></i>

                                                        </div>


                                                        <div>

                                                            <strong>
                                                                {
                                                                    subject.total_papers ||
                                                                    0
                                                                }
                                                            </strong>


                                                            <span>
                                                                {(
                                                                    subject.total_papers ||
                                                                    0
                                                                ) === 1
                                                                    ? "Paper"
                                                                    : "Papers"
                                                                }
                                                            </span>

                                                        </div>

                                                    </div>


                                                    {/* BUTTON */}

                                                    <button
                                                        type="button"
                                                        className="premium-action-btn"
                                                        onClick={() =>
                                                            openSubject(
                                                                subject.subject
                                                            )
                                                        }
                                                    >

                                                        <span>
                                                            View Papers
                                                        </span>


                                                        <i className="bi bi-arrow-right"></i>

                                                    </button>

                                                </div>

                                            </div>

                                        )
                                    )}

                                </div>

                            </section>

                        )
                    }

                </div>

            </main>

        </div>

    );

}


export default PremiumMCQ;